<crm-form-loading-indicator [loadingStatus]="loadingStatus">
  <form class="crm-model-driven-form" form-content [formGroup]="formGroup">
    <h2 mat-dialog-title>{{ 'CREATE_PAGE.TITLE' | translateByObjectType: objectType }}</h2>
    <mat-dialog-content>
      <mat-card style="border-color: transparent">
        <mat-card-content>
          @for (renderableFieldGroup of renderableFieldGroups; track renderableFieldGroup) {
            @for (renderableField of renderableFieldGroup.fields; track renderableField) {
              @if (basicGroupFieldsMap$ | async; as basicGroupFieldsMap) {
                <crm-renderer-selector
                  *ngIf="basicGroupFieldsMap.get(objectType).includes(renderableField.fieldId)"
                  [handler]="renderableField"
                ></crm-renderer-selector>
              }
            }
          }
        </mat-card-content>
      </mat-card>
      @for (renderableFieldGroup of readonlyRenderableFieldGroups; track renderableFieldGroup) {
        @for (renderableField of renderableFieldGroup.fields; track renderableField) {
          <crm-renderer-selector [handler]="renderableField"></crm-renderer-selector>
        }
      }
    </mat-dialog-content>
    <ng-template [ngTemplateOutlet]="formButtons"></ng-template>
  </form>
</crm-form-loading-indicator>
<ng-template #formButtons>
  <mat-dialog-actions>
    <button mat-stroked-button (click)="onCancel()">
      {{ 'ACTIONS.CANCEL' | translate }}
    </button>
    <button mat-flat-button color="primary" (click)="onSubmit()">Create</button>
  </mat-dialog-actions>
</ng-template>
